import { connect } from "react-redux";
import PMList from "./pmList";
import { bindActionCreators } from "redux";
import { fetchPmGateDetails, siteSchedule, engineerList} from "services/redux/maintenance/pmList/action";

const mapStateToProps = (state) => ({
  pmListData: state.pmListReducer.pmListData,
  engineerListData: state.pmListReducer.engineerListData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmGateDetails,
      siteSchedule,
      engineerList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PMList);
